module.exports = __webpack_public_path__ + "media/src/images/covers/sidebar-cover-37a4e4cf1c649536e6bc7e6dc5eb5a3f.jpg";